<script>
export default {
  props: {
    progressEvent: ProgressEvent,
  },
  computed: {
    percent() {
      if (!this.progressEvent) {
        return 0
      }
      let percent = 0
      const totalLength = this.progressEvent.lengthComputable
        ? this.progressEvent.total
        : this.progressEvent.target.getResponseHeader('content-length') ||
          this.progressEvent.target.getResponseHeader(
            'x-decompressed-content-length'
          )

      if (totalLength !== null) {
        percent = Math.round((this.progressEvent.loaded * 100) / totalLength)
      }

      if (percent === 100) this.$emit('finished')
      return percent
    },
  },
}
</script>

<template>
  <div class="loading-bar">
    <div class="bar bg-green-400 h-full" :style="{ width: percent + '%' }">
      &nbsp;
    </div>
  </div>
</template>
